export const routes = {
  root: {
    path: "/",
  },
  auth: {
    path: "/auth",
    absolute: "/auth",
  },
  signIn: {
    path: "/sign-in",
    absolute: "/sign-in",
  },
  authCallback: {
    path: "/auth/callback",
    absolute: "/auth/callback",
  },
  resetPassword: {
    path: "/reset-password",
    absolute: "/reset-password",
  },
  sendResetPassword: {
    path: "/send-reset-password",
    absolute: "/send-reset-password",
  },
  admin: {
    path: "/admin",
    absolute: "/admin",
  },
  approvals: {
    path: "reconciliation",
    absolute: "/admin/reconciliation",
  },
  approvals_v2: {
    path: "reconciliation",
    absolute: "/admin/reconciliation",
  },
  movement: {
    path: "movement",
    absolute: "/admin/movement",
  },
  movement_v2: {
    path: "movement",
    absolute: "/admin/movement",
  },
  movementList: {
    path: ":movementTypeId/list",
    absolute: "/admin/movement/:movementTypeId/list",
  },
  movementViews: {
    path: "views/list",
    absolute: "/admin/movement/views/list",
  },
  movementEdit: {
    path: "movement/:movementId/edit",
    absolute: "/admin/movement/:movementId/edit",
  },
  movementEdit_v2: {
    path: "movement/:movementId/edit",
    absolute: "/admin/movement/:movementId/edit",
  },
  data: {
    path: "data/conciliation/upload",
    absolute: "/admin/data/conciliation/upload",
  },
  data_v2: {
    path: "data/conciliation/upload",
    absolute: "/admin/data/conciliation/upload",
  },
  sources: {
    path: "sources",
    absolute: "/admin/sources",
  },
  sources_v2: {
    path: "sources",
    absolute: "/admin/sources",
  },
  views: {
    path: "views",
    absolute: "/admin/views",
  },
  views_v2: {
    path: "views",
    absolute: "/admin/views",
  },
};
